import { render, staticRenderFns } from "./SingleClientHealthFacility.vue?vue&type=template&id=74fc5ee4&"
import script from "./SingleClientHealthFacility.vue?vue&type=script&lang=js&"
export * from "./SingleClientHealthFacility.vue?vue&type=script&lang=js&"
import style0 from "./SingleClientHealthFacility.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports